import { AsyncPipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import { TagDirective } from '@app/core/directives/tag.directive';
import { ImageTag } from '@app/entities/images/interfaces/image-tag';
import { TagsComponent } from '@app/layout/tags/tags.component';
import { ImageSelectors } from '@app/store';
import { Store } from '@ngxs/store';
import { map, Observable } from 'rxjs';

@Component({
  selector: 'app-item-tags',
  templateUrl: './item-tags.component.html',
  styleUrls: ['./item-tags.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TagsComponent],
})
export class ItemTagsComponent implements OnInit {
  protected imageTags$: Observable<ImageTag[] | undefined> = inject(
    Store,
  ).select(ImageSelectors.imageTags) as Observable<ImageTag[] | undefined>;

  protected tags$!: Observable<string[] | undefined>;

  ngOnInit(): void {
    this.tags$ = this.imageTags$.pipe(
      map((imageTags: ImageTag[] | undefined) => {
        if (!imageTags) {
          return undefined;
        }

        return imageTags.map((imageTag: ImageTag) => {
          return imageTag.name;
        });
      }),
    );
  }
}
